<template>
    <b-button
        :native-type="type"
        :class="[
            {
                'min-width': text && minWidth,
            },
        ]"
        :disabled="disabled"
        :type="`is-${bgColor}`"
        :loading="loading"
        size="is-large"
        :outlined="outlined"
        @focus.native="focused = true"
        @blur.native="focused = false"
        @mouseenter="hovered = true"
        @mouseleave="hovered = false"
        @click.native="onClick($event)"
    >
        <div class="ls-button--content" test-id="content">
            <div v-if="icon" style="display: flex;" :class="{ 'add-right-padding': text }">
                <LsIcon
                    :size-override="iconSizeOverride"
                    :type="icon"
                    :color="normalizedTextColor"
                />
            </div>
            <span v-if="text" class="ls-button--text" :class="`has-text-${normalizedTextColor}`">{{
                text | titleCase
            }}</span>
        </div>
    </b-button>
</template>

<script>
import _ from 'lodash';
import VueTypes from 'vue-types';
import { lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';
import { lsColors } from '@/constants';
import LsIcon from '@/components/common/LsIcon/LsIcon.vue';
import { LsIconTypes } from '@/components/common/LsIcon/LsIcon.constants';

export default {
    name: 'LsButton',
    components: {
        LsIcon,
    },
    props: {
        trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
        text: VueTypes.string,
        icon: VueTypes.oneOf(LsIconTypes),
        type: VueTypes.oneOf(['button', 'submit']).def('button'),
        bgColor: VueTypes.oneOf(_.keys(lsColors)).def('primary'),
        textColor: VueTypes.oneOf(_.keys(lsColors)).def('white'),
        loading: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
        minWidth: VueTypes.bool.def(true),
        outlined: VueTypes.bool.def(false),
        iconSizeOverride: VueTypes.integer,
    },
    data() {
        return {
            hovered: false,
            focused: false,
        };
    },
    computed: {
        normalizedTextColor() {
            if (this.loading) {
                return lsColors.transparent;
            }
            if ((this.outlined && this.hovered) || this.focused) {
                return `${this.bgColor}-invert`;
            }

            return this.textColor;
        },
    },
    methods: {
        onClick(evt) {
            lsTrackingService.track({ event: 'click', target: this.trackId });
            this.$emit('click', evt);
        },
    },
};
</script>

<style lang="scss" scoped>
button {
    height: 38px;
    display: flex;
}

.ls-button--content {
    display: flex;
}

.ls-button--text {
    font-weight: $semi-bold;
}

.add-right-padding {
    padding-right: 10px;
}

.min-width {
    min-width: 130px;
}
</style>
